import { FrameWorkFormatDate, FrameWorkGetPrimaryColorButton, FrameWorkGetSecundaryColorButton, FrameWorkHideAlert, FrameWorkMessageAceptCancel, FrameWorkMessageErrorAlert, FrameWorkSimpleMessageState, OrdenExpressButtonSwitch, OrdenExpressIsAdmin, OrdenExpressNavegatePath, OrdenExpressValidateSecurity } from 'orden_express/frameWork/frameWork';
import { setListOfProductsForBeginingOrder, setMessageOrdersRequested } from 'orden_express/orders/ordersActions';
import { requestGetOrderRequestedDetail, requestSaveOrderProductDetail } from 'orden_express/orders/ordersEpic';
import { setOriginRequestList } from 'orden_express/products/productsActions';
import React from 'react';
import { connect } from 'react-redux';
import { Button, ButtonGroup, Card, CardBody, Col, FormGroup, Input, Row, UncontrolledTooltip } from 'reactstrap';
import { bindActionCreators } from 'redux';



class OrderDetail extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      alert: '',
      lastWasDelete: false,
    }
    OrdenExpressValidateSecurity(this);
    this.props.setMessageOrdersRequested(1);
    this.props.requestGetOrderRequestedDetail(this.props.ordersReducerState.dataOrderForShowAndEdit);
  }

  componentDidUpdate(prevProps) {
    if (this.props.ordersReducerState.messageOrdersRequested !== prevProps.ordersReducerState.messageOrdersRequested) {
      this.processMessageState(this.props.ordersReducerState.messageOrdersRequested);
    }
    if (this.props.ordersReducerState.responseSaveOrderProductDetail !== prevProps.ordersReducerState.responseSaveOrderProductDetail) {
      //responseGetOrderRequestedDetail: action.responseSaveOrderProductDetail,//esta es la prueba
      if (this.state.lastWasDelete === true) {
        this.props.setMessageOrdersRequested(1);
        this.props.requestGetOrderRequestedDetail(this.props.ordersReducerState.dataOrderForShowAndEdit);
      }
    }
  }

  processMessageState = (pStateForMessage) => {
    switch (pStateForMessage) {
      case 1://procesando solicitud
        FrameWorkSimpleMessageState(this, 'Recuperando datos de orden', 'Se está procesando ...');
        break;
      case 2:
        FrameWorkHideAlert(this);
        this.props.setMessageOrdersRequested(0);
        break;
      case 3:
        var localMessageError = this.props.ordersReducerState.responseGetOrdersRequested;
        FrameWorkMessageErrorAlert(this, 'Error :(', localMessageError.message);
        console.error(localMessageError)
        break;
      default:
        FrameWorkHideAlert(this);
        this.props.setMessageOrdersRequested(0);
        break;
    }
  }

  renderButtonAddProduct = () => {
    if (OrdenExpressIsAdmin(this)) {
      return (
        <Button
          color={FrameWorkGetPrimaryColorButton()}
          className='btn-round mb-0 mt-1 ml-6'
          onClick={() => {
            //this.props.history.push('/admin/products?isFromOrders=true');
            OrdenExpressNavegatePath(this, 'products?isFromOrders=true');
          }
          }
          style={{ width: 145 }}
        >
          <i className='icon-big nc-icon nc-box text-white' />
          {'+ producto'}
        </Button>
      );
    }
    return (<></>);
  }

  renderheaderButtons = () => {
    return (
      <div className='text-right'>
        <Button
          color={FrameWorkGetSecundaryColorButton()}
          className='btn-round mb-0 mt-1 ml-6'
          onClick={() => {
            try {
              this.props.history.goBack();
            } catch (_) {
              //this.props.history.push('/admin/processOrders');
              OrdenExpressNavegatePath(this, 'processOrders');
            }
          }
          }
          style={{ width: 145 }}
        >
          <i className='icon-big nc-icon nc-minimal-left text-white' />
          {'Regresar'}
        </Button>
        {this.renderButtonAddProduct()}
      </div>
    )
  }

  renderQuantityProductRequestedChange = (pActualValue, pIndex) => {
    if (OrdenExpressIsAdmin(this)) {
      return (
        <Input
          id={`quantityRequest${pIndex}`}
          placeholder='Cantidad'
          type='number'
          style={{ width: 120 }}
          value={pActualValue}
          readOnly
        />
      )
    }
    return (
      <>
        {pActualValue}
        {' '}
      </>
    )
  }


  renderQuantityProductDispatchedChange = (pLocalProduct, pActualValue, pIndex) => {
    if (OrdenExpressIsAdmin(this)) {
      return (
        <Input
          id={`quantityDispatch${pIndex}`}
          placeholder='Cantidad'
          type='number'
          style={{ width: 120, }}
          value={pActualValue}

          onChange={(event) => {
            if (event.target.value !== '') {
              if (event.target.value === 0) {
                event.target.value = 1;
              } else if (event.target.value < 0) {
                event.target.value = Math.abs(event.target.value);
              }
            }
            var copiaLocalPoduct = pLocalProduct;
            copiaLocalPoduct.quantityShipped = event.target.value;
            this.saveChangeProduct(copiaLocalPoduct);
          }}
        />
      )
    }
    return (
      <>
        {pActualValue}
        {' '}
      </>
    )
  }

  renderButtonChangeQuantity = (pLocalProduct, pActualValue) => {
    pActualValue = parseInt(pActualValue, 10);
    if (isNaN(pActualValue)) {
      pActualValue = 0;
    }
    return (
      <ButtonGroup className='btn-group-sm mt-0 mb-0' key={``}>
        <Button
          className='btn-round mt-0 mb-0'
          color='default'
          outline
          onClick={event => {
            var localValue = pActualValue;
            localValue -= 1;
            if (localValue === 0) {
              localValue = 1;
            } else if (localValue < 0) {
              localValue = Math.abs(localValue);
            }
            var copiaLocalPoduct = pLocalProduct;
            copiaLocalPoduct.quantityShipped = localValue;
            this.saveChangeProduct(copiaLocalPoduct);
          }}
        >
          <i className='nc-icon nc-simple-delete' />
        </Button>
        <Button
          className='btn-round mt-0 mb-0'
          color='default'
          outline
          onClick={event => {
            var localValue = pActualValue;
            localValue += 1;
            if (localValue === 0) {
              localValue = 1;
            } else if (localValue < 0) {
              localValue = Math.abs(localValue);
            }
            var copiaLocalPoduct = pLocalProduct;
            copiaLocalPoduct.quantityShipped = localValue;
            this.saveChangeProduct(copiaLocalPoduct);
          }}
        >
          <i className='nc-icon nc-simple-add' />
        </Button>
      </ButtonGroup>
    )
  }

  applyFilters = (pData) => {
    return pData;
  }

  renderFilters = () => {
    return (
      ''
    );
  }

  /**
   * 
   */
  saveChangeProduct = (plocalProduct, isForDelete = false) => {
    this.setState({ lastWasDelete: isForDelete });//Esta bandera es para volver a recuperar todos los datos si la última operación fue de borrado.
    plocalProduct['forDelete'] = isForDelete;//CUIDADO QUE ES UN BORRADO FÍSICO DELETE DE BASE DE DATOS
    this.props.requestSaveOrderProductDetail(plocalProduct);
  }

  getDateFormat = (pData) => {
    return FrameWorkFormatDate(pData);
  }

  changeStateOrder = (label, value, pLocalProduct) => {
    var copiaLocalPoduct = pLocalProduct;
    copiaLocalPoduct[label] = value;
    this.saveChangeProduct(copiaLocalPoduct);
  }

  renderProductPack = (pLocalProduct, pIndexProduct) => {
    return (
      <FormGroup className='pl-0 ml-0 mt-0 mb-0'>
        <div>
          {
            OrdenExpressButtonSwitch('packed', 'On', 'Off', pLocalProduct, this.changeStateOrder)}
          {/*
          <Switch
            key={`switchPacked${pIndexProduct}`}
            id={`switchPacked${pIndexProduct}`}
            style={{ transform: [{ scaleX: .8 }, { scaleY: .8 }] }}
            value={pLocalProduct.packed === 0 ? false : true}
            offColor='success'
            offText={<i className='nc-icon nc-simple-remove' />}
            onColor='success'
            onText={<i className='nc-icon nc-check-2' />}
            onChange={
              (el, state) => {
                var copiaLocalPoduct = pLocalProduct;
                copiaLocalPoduct.packed = state == true ? 1 : 0;
                this.saveChangeProduct(copiaLocalPoduct);
              }
            }
          />*/}
        </div>
      </FormGroup>
    );
  }

  renderProductDispatch = (pLocalProduct, pIndexProduct) => {
    var copiaLocalPoduct = pLocalProduct;
    return (
      <FormGroup className='pl-0 ml-0 mt-0 mb-0'>
        <div>
          {OrdenExpressButtonSwitch('dispatched', 'On', 'Off', copiaLocalPoduct, this.changeStateOrder)}
          {/*<Switch
            key={`switchDispatched${pIndexProduct}`}
            id={`switchDispatched${pIndexProduct}`}
            value={pLocalProduct.dispatched === 0 ? false : true}
            offColor='success'
            offText={<i className='nc-icon nc-simple-remove' />}
            onColor='success'
            onText={<i className='nc-icon nc-check-2' />}
            onChange={
              (el, state) => {
                var copiaLocalPoduct = pLocalProduct;
                copiaLocalPoduct.dispatched = state == true ? 1 : 0;
                this.saveChangeProduct(copiaLocalPoduct);
              }
            }
          />{' '}*/}
        </div>
      </FormGroup>
    );
  }

  renderButtonsEditOrder = (itemProduct, indexproduct, widthForLbels) => {
    if (!OrdenExpressIsAdmin(this)) {
      return (<></>);
    }
    return (
      <>
        <Col xs={2.5}>
          <div className='d-inline-block mt-1 mb-0'>
            <div className='d-inline-block mt-0 mb-0'>
              {this.renderProductPack(itemProduct, indexproduct)}
            </div>
            <br />
            <div className='d-inline-block mr-2' style={{ width: widthForLbels }}>
              <b>{'Alistar'}</b>
            </div>
          </div>
        </Col>
        <Col xs={2.5}>
          <div className='d-inline-block mt-1 mb-0'>
            <div className='d-inline-block mt-0 mb-0'>
              {this.renderProductDispatch(itemProduct, indexproduct)}
            </div>
            <br />
            <div className='d-inline-block' style={{ width: widthForLbels }}>
              <b>{'Despachar'}</b>
            </div>
          </div>
        </Col>
      </>
    )/*
    if (OrdenExpressIsAdmin(this)) {
      return (
        <>
          <Row className='mt-1'>
            <Col sm='auto'
              className='pr-0 ml-0'
              style={{ width: widthForLbels }}>
              <b>{'Alistar'}</b>
            </Col>
            <Col>
              {this.renderProductPack(itemProduct, indexproduct)}
            </Col>
          </Row>
          <Row>
            <Col sm='auto'
              className='pr-0 ml-0'
              style={{ width: widthForLbels }}>
              <b>{'Despachar'}</b>
            </Col>
            <Col >
              {this.renderProductDispatch(itemProduct, indexproduct)}
            </Col>
          </Row>
        </>

      )
    }
    return (<></>);*/
  }

  renderButtonPlusMinusQuantity = (itemProduct, widthForLbels) => {
    if (OrdenExpressIsAdmin(this)) {
      return (
        <div className='d-inline-block'>
          {this.renderButtonChangeQuantity(itemProduct, itemProduct.quantityShipped)}
        </div>
      );
      /*return (
        <>
          <br />
          <div className='d-inline-block mt-1 mb-0'>
            <div className='d-inline-block mr-1' style={{ width: widthForLbels }}>
              <b>{'Modificar'}</b>
            </div>
            <div className='d-inline-block'>
              {this.renderButtonChangeQuantity(itemProduct, itemProduct.quantityShipped)}
            </div>
          </div>
          <br />
        </>
      );*/
    }
    return (<></>);
  }

  deleteProductConfirmed = (pProduct) => {
    this.saveChangeProduct(pProduct.product, true);
  }

  messageDeleteProductList = (pProduct, pIndex) => {
    FrameWorkMessageAceptCancel(
      this,
      'Borrar ' + pProduct.productContent.name,
      '¿Desea borrar el producto seleccionado?',
      this.deleteProductConfirmed,
      null,
      { product: pProduct, index: pIndex },
      null,
      'alert'
    );
  }

  renderDeleteButtonProduct = (pProduct, widthForLbels, pIndex) => {
    if (!OrdenExpressIsAdmin(this)) {
      return (<></>);
    }
    return (
      <>
        <div className='d-inline-block mt-2 mb-0'>
          <div className='d-inline-block mt-0 mb-0 ml-2'>
            <Button
              className='btn-icon btn-round mt-1 mb-0'
              color={FrameWorkGetPrimaryColorButton()}
              id={`deleteProduct${pIndex}`}
              type='button'
              outline
              size='lg'

              disabled={pProduct.active !== 1 ? true : false}
              onClick={value => {
                this.messageDeleteProductList(pProduct, pIndex);
              }}
            >
              <i className='fa fa-trash' />
            </Button>
            <UncontrolledTooltip
              delay={0}
              target={`deleteProduct${pIndex}`}
            >
              Borrar producto
          </UncontrolledTooltip>
          </div>
        </div>
        <br />
        <div className='d-inline-block mr-1 ml-3' style={{ width: widthForLbels }}>
          <b>{'Borrar'}</b>
        </div>
      </>

    )
  }

  weightCalculateOut = (localProducts) => {
    var weightCalculated = 0;
    var pos = 0;
    var length = localProducts.length;
    while (pos < length) {
      var itemProduct = localProducts[pos];
      weightCalculated += itemProduct.productContent.weight * itemProduct.quantityShipped;
      pos++;
    }
    return weightCalculated.toFixed(1) || '';
  }

  render() {
    var localOrderRequested = {};
    var localProducts = [];
    try {
      localOrderRequested = this.props.ordersReducerState.responseGetOrderRequestedDetail.result || {};
    } catch (__) { }
    try {
      localProducts = this.applyFilters(localOrderRequested.orderDetails) || [];
    } catch (_) { }
    var localUser = {};
    try {
      localUser = localOrderRequested.user || {};
    } catch (__) { }
    var localDeliveryPoint = {};
    try {
      localDeliveryPoint = localUser.deliveryPoints[0] || {};
    } catch (__) { }
    var weightCalculated = this.weightCalculateOut(localProducts);
    var lastIndex = 0;
    var widthForLbels = 94;
    return (
      <div className='content mt-5 mb-0'>
        {this.state.alert}

        <div className='framework-flexcontainer'>
          <div>
            <h4>{'Orden'}</h4>
          </div>
          <div className='text-right framework-flex-rigth'>
            <br />
            {this.renderheaderButtons()}
          </div>
        </div>

        <div>
          <Card className='mt-1 mb-1'>
            <CardBody>
              {this.renderFilters()}
              <span >
                <b>
                  {'Nº'}
                </b>{' '}
                {localOrderRequested.id}
                <div>
                  <b>
                    {'Fecha de despacho'}
                  </b>{' '}
                  {this.getDateFormat(localOrderRequested.dispatchDate || '')}
                </div>
                <div>
                  <b>
                    {'Fecha de entrega'}
                  </b>{' '}
                  {this.getDateFormat(localOrderRequested.deliveryDate || '')}
                </div>
                <div>
                  <b>Cliente</b>{' '}
                  {localUser.typeIdentification || ''}{': '}
                  {localUser.identification || ''}{' '}
                  {localUser.name || ''}{' '}
                  {localUser.phone || ''}{' '}
                  {localUser.email || ''}
                </div>
                <div>
                  <b>Punto de entrega</b>{' '}
                  {localDeliveryPoint.name || ''}{' '}
                  {localDeliveryPoint.cityName || ''}{' '}
                  {localDeliveryPoint.address || ''}
                </div>
              </span>
            </CardBody>
          </Card>
        </div>
        <Card
          className={`mt-0 mb-1 ${lastIndex % 2 === 0 ? 'bg-gray' : 'bg-white'}`}
        >
          <CardBody>
            <div>
              <span >
                <b>Nº de productos</b>{' '}
                {
                  localProducts.length
                }
                {' '}
              </span>
              <br />
              <span >
                <b>Peso total</b>{' '}
                {
                  weightCalculated
                }
                {' Kilos'}
              </span>
            </div>
          </CardBody>
        </Card>
        {
          localProducts.map((itemProduct, indexproduct) => {
            //weightCalculated += itemProduct.productContent.weight * itemProduct.quantityShipped;
            lastIndex = indexproduct + 1;
            return (
              <>
                <Card
                  className={`mt-0 mb-1 ${indexproduct % 2 === 1 ? 'bg-gray' : 'bg-white'}`}
                  key={`idRowTableProducts${indexproduct}`}
                >
                  <CardBody>
                    <Row>
                      <Col>
                        <div className='d-inline-block'>
                          <div className='d-inline-block mr-1'>
                            <b>{'Código:'}</b>
                          </div>
                          <div className='d-inline-block'>
                            {itemProduct.productContent.code}
                          </div>
                        </div>
                        <br />
                        <b>
                          {itemProduct.productContent.name}
                          {' ('}
                          {itemProduct.productContent.nameMeasureUnit}
                          {')'}
                        </b>
                        <br />
                        <div className='d-inline-block'>
                          <div className='d-inline-block mr-1'>
                            <b>{'Peso:'}</b>
                          </div>
                          <div className='d-inline-block'>
                            {(itemProduct.productContent.weight * itemProduct.quantityShipped).toFixed(1) || ''}
                          </div>
                          <div className='d-inline-block ml-1'>
                            {'kilos'}
                          </div>
                        </div>
                        <br />
                        <div className='d-inline-block'>
                          <div className='d-inline-block mr-1' style={{ width: widthForLbels }}>
                            <b>{'Solicitado:'}</b>
                          </div>
                          <div className='d-inline-block'>
                            <div className='d-inline-block mr-1'>
                              {this.renderQuantityProductDispatchedChange(itemProduct, itemProduct.quantityShipped, indexproduct)}
                            </div>
                            {this.renderButtonPlusMinusQuantity(itemProduct, widthForLbels)}
                            <div className='d-inline-block'>
                              {itemProduct.productContent.nameMeasureUnit}
                            </div>
                          </div>
                        </div>
                        <Row>
                          <Col xs={2.5}>
                            {this.renderDeleteButtonProduct(itemProduct, widthForLbels, indexproduct)}
                          </Col>
                          {this.renderButtonsEditOrder(itemProduct, indexproduct, widthForLbels)}
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                {/*
                <Card
                  className={`mt-0 mb-1 ${indexproduct % 2 === 1 ? 'bg-gray' : 'bg-white'}`}
                  key={`idRowTableProducts${indexproduct}`}
                >
                  <CardBody>
                    <Row>
                      <Col>
                        <div className='framework-flexcontainer mb-0 mt-0'>
                          <div className='pt-3'>

                            <div className='d-inline-block'>
                              <div className='d-inline-block mr-1'>
                                <b>{'Código:'}</b>
                              </div>
                              <div className='d-inline-block'>
                                {itemProduct.productContent.code}
                              </div>
                            </div>
                            <br />
                            <b>
                              {itemProduct.productContent.name}
                              {' ('}
                              {itemProduct.productContent.nameMeasureUnit}
                              {')'}
                            </b>
                            <br />
                            <div className='d-inline-block'>
                              <div className='d-inline-block mr-1'>
                                <b>{'Peso:'}</b>
                              </div>
                              <div className='d-inline-block'>
                                {(itemProduct.productContent.weight * itemProduct.quantityShipped).toFixed(1) || ''}
                              </div>
                              <div className='d-inline-block ml-1'>
                                {'kilos'}
                              </div>
                            </div>

                          </div>
                          <span className='framework-flex-rigth text-right'>
                            <span>
                              <Badge
                                className='mt-0 mb-1'
                                id={`idBadgedActive${indexproduct}`}
                                style={{ width: 105 }}
                                color={itemProduct.active === 1 || itemProduct.active === true ? 'success' : 'danger'}
                                pill>
                                {itemProduct.active === 1 || itemProduct.active === true ? 'Activo' : 'Inactivo'}
                              </Badge>
                              <br />
                              <Badge
                                className='mt-0 mb-1'
                                id={`idBadgedPacked${indexproduct}`}
                                style={{ width: 105 }}
                                color={itemProduct.packed === 1 || itemProduct.packed === true ? 'success' : 'danger'}
                                pill>
                                {itemProduct.packed === 1 || itemProduct.packed === true ? 'Alistado' : 'Sin alistar'}
                              </Badge>
                              <br />
                              <Badge
                                className='mt-0 mb-0'
                                id={`idBadgedDispatched${indexproduct}`}
                                style={{ width: 105 }}
                                color={itemProduct.dispatched === 1 || itemProduct.dispatched === true ? 'success' : 'danger'} pill>
                                {itemProduct.dispatched === 1 || itemProduct.dispatched === true ? 'Despachado' : 'Sin despachar'}
                              </Badge>
                              <br />
                            </span>
                          </span>
                        </div>
                        <div className='framework-flexcontainer mb-0 mt-0'>
                          <div className='d-inline-block'>
                            <div className='d-inline-block'>
                              <div className='d-inline-block mr-1' style={{ width: widthForLbels }}>
                                <b>{'Solicitado: '}</b>
                              </div>
                              <div className='d-inline-block'>
                                <div className='d-inline-block mr-1'>
                                  {this.renderQuantityProductRequestedChange(itemProduct.quantityRequested, indexproduct)}
                                </div>
                                <div className='d-inline-block'>
                                  {itemProduct.productContent.nameMeasureUnit}
                                </div>
                              </div>
                            </div>
                            <br />
                            <div className='d-inline-block'>
                              <div className='d-inline-block mr-1' style={{ width: widthForLbels }}>
                                <b>{'Dispuesto:'}</b>
                              </div>
                              <div className='d-inline-block'>
                                <div className='d-inline-block mr-1'>
                                  {this.renderQuantityProductDispatchedChange(itemProduct, itemProduct.quantityShipped, indexproduct)}
                                </div>
                                <div className='d-inline-block'>
                                  {itemProduct.productContent.nameMeasureUnit}
                                </div>
                              </div>
                            </div>
                            {this.renderButtonPlusMinusQuantity(itemProduct, widthForLbels)}
                            {this.renderDeleteButtonProduct(itemProduct, widthForLbels, indexproduct)}
                          </div>
                          <div className='framework-flex-rigth mr-1'>
                            <span id={`moreInformation${indexproduct}`}>
                              <i className='fa fa-ellipsis-v mr-0' />
                            </span>
                            <UncontrolledTooltip
                              delay={0}
                              target={`moreInformation${indexproduct}`}
                            >
                              {itemProduct.productContent.information}
                            </UncontrolledTooltip>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {this.renderButtonsEditOrder(itemProduct, indexproduct, widthForLbels)}
                  </CardBody>
                /Card>*/}
              </>
            )
          })
        }
        <Card
          className={`mt-0 mb-1 ${lastIndex % 2 === 1 ? 'bg-gray' : 'bg-white'}`}
          key={`idRowTableProducts${lastIndex}`}
        >
          <CardBody>
            <div>
              <span >
                <b>Nº de productos</b>{' '}
                {
                  localProducts.length
                }
                {' '}
              </span>
              <br />
              <span >
                <b>Peso total</b>{' '}
                {
                  weightCalculated
                }
                {' Kilos'}
              </span>
            </div>
          </CardBody>
        </Card>
        <div className='framework-flexcontainer'>
          <div>
            <h4>{''}</h4>
          </div>
          <div className='text-right framework-flex-rigth'>
            <br />
            {this.renderheaderButtons()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ordersReducerState: state.ordersReducerState,
    reportsReducerState: state.reportsReducerState,
    loginReducerState: state.loginReducerState,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setListOfProductsForBeginingOrder: (listOfProductsForBeginingOrder) => dispatch(setListOfProductsForBeginingOrder(listOfProductsForBeginingOrder)),
    setOriginRequestList: (originRequestListsetOriginRequestList) => dispatch(setOriginRequestList(originRequestListsetOriginRequestList)),
    setMessageOrdersRequested: (messageOrdersRequested) => dispatch(setMessageOrdersRequested(messageOrdersRequested)),

    requestGetOrderRequestedDetail: (dataRequestGetOrderRequestedDetail) => bindActionCreators(dispatch(requestGetOrderRequestedDetail(dataRequestGetOrderRequestedDetail)), dispatch),
    requestSaveOrderProductDetail: (dataRequestSaveOrderProductDetail) => bindActionCreators(dispatch(requestSaveOrderProductDetail(dataRequestSaveOrderProductDetail)), dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetail);